var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, Type } from '@decahedron/entity';
import { orderBy } from 'lodash';
import moment from 'moment';
import FORMATS from 'config/formats';
import { Campaign } from 'packages/target/entities/Campaign';
import { User } from 'packages/users/User';
var PipelineSummary = /** @class */ (function (_super) {
    __extends(PipelineSummary, _super);
    function PipelineSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hire = 0;
        _this.other = 0;
        _this.rejection = 0;
        _this.entry = 0;
        return _this;
    }
    return PipelineSummary;
}(Entity));
export { PipelineSummary };
var JobSummary = /** @class */ (function (_super) {
    __extends(JobSummary, _super);
    function JobSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.numberOfUnreadMails = null;
        _this.location = null;
        _this.title = null;
        _this.status = null;
        _this.activeTo = null;
        _this.activeFrom = null;
        _this.createdAt = null;
        _this.updatedAt = null;
        _this.archivedAt = null;
        _this.isStarred = false;
        _this.isHidden = true;
        _this.pipeline = null;
        _this.campaigns = [];
        _this.subscribers = [];
        return _this;
    }
    Object.defineProperty(JobSummary.prototype, "totalCandidates", {
        get: function () {
            return Object.values(this.pipeline).reduce(function (a, b) { return a + b; }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobSummary.prototype, "lastOfCampaigns", {
        get: function () {
            var _a;
            if (!this.hasCampaign) {
                return null;
            }
            return (_a = orderBy(this.campaigns, ['startsAt'], ['desc'])) === null || _a === void 0 ? void 0 : _a[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobSummary.prototype, "activeToDate", {
        get: function () {
            return moment(this.activeTo).format(FORMATS.DATE.UI);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobSummary.prototype, "isArchived", {
        get: function () {
            return this.archivedAt !== null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobSummary.prototype, "hasScheduledCampaign", {
        get: function () {
            return !!this.campaigns.find(function (campaign) { return campaign.isScheduled; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobSummary.prototype, "hasActiveCampaign", {
        get: function () {
            return !!this.campaigns.find(function (campaign) { return campaign.isActive; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobSummary.prototype, "hasCampaign", {
        get: function () {
            return this.campaigns.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JobSummary.prototype, "campaignStatus", {
        get: function () {
            if (!this.hasCampaign) {
                return null;
            }
            else if (this.hasScheduledCampaign) {
                return 'scheduled';
            }
            else if (this.hasActiveCampaign) {
                return 'active';
            }
            return 'expired';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Type(PipelineSummary),
        __metadata("design:type", PipelineSummary)
    ], JobSummary.prototype, "pipeline", void 0);
    __decorate([
        Type(Campaign),
        __metadata("design:type", Array)
    ], JobSummary.prototype, "campaigns", void 0);
    __decorate([
        Type(User),
        __metadata("design:type", Array)
    ], JobSummary.prototype, "subscribers", void 0);
    return JobSummary;
}(Entity));
export { JobSummary };
